export const calcLastActivity = (activities = []) => {
  const activities_with_date = activities.filter(activity => activity.date);
  console.log(activities_with_date);
  const latest = activities_with_date.reduce((a, b) => (new Date(a.date) < new Date(b.total_offer) ? a : b), {
    initial_date: new Date(0),
  });
  console.log(latest.date);
  return latest;
};
